import axios from 'axios';

const api = axios.create({
    baseURL: '/api',
    timeout: 30000,
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
});

api.interceptors.response.use(
    response => response,
    error => {
        if (error.response?.status === 401 && !error.config?.url?.startsWith('/auth/')) {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            if (typeof window !== 'undefined' && window.location.pathname !== '/login') {
                window.location.href = '/login';
            }
        }
        return Promise.reject(error);
    }
);

export const endpoints = {
    auth: {
        config: () => api.get('/auth/config'),
        me: () => api.get('/auth/me'),
        mockLogin: (username) => api.post('/auth/mock-login', { username }),
        logout: () => api.post('/auth/logout'),
    },
    expedientes: {
        list: (params) => api.get('/expedientes', { params }),
        tenants: () => api.get('/expedientes/tenants'),
        get: (id) => api.get(`/expedientes/${id}`),
        create: (data) => api.post('/expedientes', data),
        update: (id, data) => api.put(`/expedientes/${id}`, data),
        log: (id, data) => api.post(`/expedientes/${id}/log`, data),
        downloadUrl: (faseId) => `/api/expedientes/descargar/${faseId}`,
        resetFase1: (id) => api.post(`/expedientes/${id}/reset-fase1`),
        resetFase2: (id, nrbe) => api.post(`/expedientes/${id}/reset-fase2`, { nrbe }),
        resetFase3: (id, nrbe) => api.post(`/expedientes/${id}/reset-fase3`, { nrbe }),
        archivar: (id, archivar) => api.put(`/expedientes/${id}/archivar`, { archivar }),
    },
    n63: {
        paysDisponibles: (crId) => api.get('/n63/pays-disponibles', { params: { cr_id: crId } }),
        bancosDisponibles: (crId) => api.get('/n63/bancos-disponibles', { params: { cr_id: crId } }),
        generarFase1: (expId, data) => api.post(`/n63/${expId}/generar-fase1`, data),
        importarFase2: (expId, file) => {
            const form = new FormData();
            form.append('fichero', file);
            return api.post(`/n63/${expId}/importar-fase2`, form, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
        },
        pendientesFase3: (expId, nrbe) => api.get(`/n63/${expId}/fase2-pendientes/${nrbe}`),
        resumenFase3: (expId, nrbe) => api.get(`/n63/${expId}/resumen-fase3/${nrbe}`),
        generarFase3: (expId, data) => api.post(`/n63/${expId}/generar-fase3`, data),
        verificarPays: (expId) => api.get(`/n63/${expId}/verificar-pays`),
        retornos: (expId) => api.get(`/n63/${expId}/retornos`),
        previewRetorno: (expId, file) => {
            const form = new FormData();
            form.append('fichero', file);
            return api.post(`/n63/${expId}/retornos/preview`, form, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
        },
        confirmarRetorno: (expId, file, token) => {
            const form = new FormData();
            form.append('fichero', file);
            form.append('token', token);
            return api.post(`/n63/${expId}/retornos/confirmar`, form, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
        },
        originalRetorno: (expId, retornoId) => api.get(`/n63/${expId}/retornos/${retornoId}/original`, {
            responseType: 'blob',
        }),
    },
};

export default api;
